import { VerticalNavigationTabs, VerticalNavigationTabsGroup } from "features/shared/components/VerticalNavigationTabs";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { dataLabels } from "../../configs/TechnicalDataEnums";
import { sentenceCase } from "../../utils/namesManipulation";

type Props = {
  activeTab: string;
  className?: string;
  enabledTabs?: string[];
  setActiveTab: (tabId: string) => void;
};

export const NavMenu = ({ activeTab, className, enabledTabs, setActiveTab }: Props) => {
  const { t } = useTranslation();

  const groups: VerticalNavigationTabsGroup[] = useMemo(
    () =>
      Object.keys(dataLabels).map((groupLabel) => ({
        items: dataLabels[groupLabel as keyof typeof dataLabels].map((data) => ({
          disabled: !enabledTabs?.includes(data.dataKey),
          id: data.dataKey,
          label: t(`TechnicalData.nav.${data.keyInI18n}`),
        })),
        label: sentenceCase(t(`TechnicalData.nav.${groupLabel}`)) ?? "",
      })),
    [enabledTabs, t]
  );

  return (
    <VerticalNavigationTabs activeTab={activeTab} className={className} groups={groups} setActiveTab={setActiveTab} />
  );
};
